
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/content/magazine/[id]",
      function () {
        return require("private-next-pages/content/magazine/[id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/content/magazine/[id]"])
      });
    }
  